import { Vue, Component } from "vue-property-decorator";
import SideMenu from "@/components/SideMenu.tsx";
import Card from "@/components/Card";
import ConsentPage from "@/components/ConsentPage";
import { CreateElement } from "vue";
import RadioTable from "@/components/RadioTable.tsx";
import VueGridLayout from "vue-grid-layout";
import "vuetify/dist/vuetify.min.css";
import firebase from "firebase/app";
import "firebase/auth";
import NotificationHandler from "./views/NotificationHandler";
import NotificationContainer from "@/components/NotificationContainer.vue";
import { Module } from "@/store/enums.ts";
import "@/styles/global.css";
import { ACCOUNT_TYPES } from "@/store/UserStore.ts";
import AutoInstruction from "./views/talk2mejr/AutoInstruction";
@Component({
  components: {
    SideMenu,
    Card,
    ConsentPage,
    RadioTable,
    NotificationContainer,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  }
})
export default class App extends Vue {
  mounted() {
    this.$store.subscribe((mutation: any, state: any) => {
      if (mutation.type == "SET_ACCOUNT_TYPE" && mutation.payload) {
        this.$forceUpdate();
      }

      if (mutation.type == "SET_CLIP" || mutation.type == "REMOVE_CLIP") {
        this.$forceUpdate();
      }
    });
  }

  private _renderSidebar() {
    const ignoreList = ["login", "home", "signup", "dashboard"];
    const name = this.$route.name;
    if (name) {
      for (let item in ignoreList) {
        if (name.includes(ignoreList[item])) {
          return false;
        }
      }
    }
    return true;
  }

  render(h: CreateElement) {
    return (
      <v-app>
        {this.$store.getters.user.loggedIn &&
          this._renderSidebar() &&
          !(this.$route.name || "").includes("consent") && <side-menu />}
        <v-app-bar app clipped-left>
          <v-toolbar-title class="headline">
            <v-btn
              text
              depressed
              ripple={false}
              style={{ textTransform: "none" }}
              tile
              x-large
              href="/"
            >
              <v-icon>mdi-brain</v-icon>
              <span>BalanceAI</span>
            </v-btn>
          </v-toolbar-title>
          <v-spacer />
          <div style={{ marginRight: "20px", zIndex: 999 }}>
            <notification-container
              style={{ height: "400px" }}
              data={this.$store.getters.notifications}
            />
          </div>

          {this.$store.getters.user.accountType == ACCOUNT_TYPES.TEACHER && (
            <div style={{ marginRight: "20px", zIndex: 999 }}>
              <v-btn
                color="accent"
                style={{ textTransform: "none" }}
                to={{ name: "dashboard-main" }}
              >
                Teacher's Dashboard
              </v-btn>
            </div>
          )}

          {this.$store.getters.user.accountType == ACCOUNT_TYPES.STUDENT && (
            <div style={{ marginRight: "20px", zIndex: 999 }}>
              <v-btn
                color="accent"
                style={{ textTransform: "none" }}
                to={{ name: "dashboard-main" }}
              >
                Student's Dashboard
              </v-btn>
            </div>
          )}
          {/* {['login', 'signup'].indexOf((this.$route as any).name) ===
						0 && (
						<v-btn color='accent' to='/consent'>
							<span class='mr-2'>Parents and Educators</span>
						</v-btn>
					)} */}
          {(this.$route as any).name &&
            (this.$route as any).name.includes("consent") && (
              <v-btn color="accent" to={{ name: "login" }}>
                Log In
              </v-btn>
            )}
          {this.$store.getters.user.loggedIn && (
            <v-btn color="accent" onclick={this._logoutUser}>
              <span class="mr-2">Log Out</span>
            </v-btn>
          )}
        </v-app-bar>
        <v-content>
          <router-view></router-view>
        </v-content>
        <v-footer app>
          <v-col>
            <span class="px-4">
              &copy; {new Date().getFullYear()} IDELA@UofT
            </span>
          </v-col>
          {this.$store.getters.availableClip && (
            <v-col>
              <v-row justify="center">
                <AutoInstruction
                  audioLocation={this.$store.getters.clip.path}
                  callbackOnProceed={this.$store.getters.clip.callbackFunction}
                ></AutoInstruction>
              </v-row>
            </v-col>
          )}
          <v-col class="text-right">
            <span>
              <a
                style={{ textDecoration: "none" }}
                target="_blank"
                href="https://www.oise.utoronto.ca/ejanglab/research/balanceai/"
              >
                About Us
              </a>
            </span>
          </v-col>
        </v-footer>
        <NotificationHandler />
      </v-app>
    );
  }

  private _logoutUser() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$store.dispatch("fetchUser", null).then(() => {
          this.$router.push("/");
        });
      })
      .catch(err => {});
  }
}

const component = App;
